import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyCL5Z73ii7T7z6KgigvKeIQQBEZ2pIIcs8",
  authDomain: "feel-my-voice.firebaseapp.com",
  databaseURL:
    "https://feel-my-voice-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "feel-my-voice",
  storageBucket: "feel-my-voice.appspot.com",
  messagingSenderId: "104243479689",
  appId: "1:104243479689:web:e605531b241fdf7f42f258",
  measurementId: "G-89LCLM71YP",
};

export function getGcpGsUrl() {
  return `gs://${firebaseConfig.storageBucket}/public`;
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// Realtime database
export const database = firebase.database();

// Verify Phone Number
export async function getRecapthaVerifierInstance() {
  if (window.recaptchaVerifier) {
    return window.recaptchaVerifier;
  }
  window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
    "verify-phone-number-btn",
    {
      size: "invisible",
    }
  );
  return window.recaptchaVerifier;
}

export async function sendConfirmationPhoneNumber(phoneNumber) {
  var appVerifier = window.recaptchaVerifier;
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithPhoneNumber(phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        return resolve(confirmationResult);
        // ...
      })
      .catch((error) => {
        reject(error);
        appVerifier.reset(0);
      });
  });
}

export async function verifyConfirmationPhoneNumber(code) {
  return new Promise((resolve, reject) => {
    window.confirmationResult
      .confirm(code)
      .then((result) => {
        // User signed in successfully.
        const user = result.user;
        return resolve(user);
      })
      .catch((error) => {
        // User couldn't sign in (bad verification code?)
        return reject(error);
      });
  });
}

// firebase storage
// Get a reference to the storage service, which is used to create references in your storage bucket
var storage = firebase.storage();

// Create a storage reference from our storage service
var storageRef = storage.ref();

export async function firebaseUploadBlob(blob, prefix, fileName, onProgressFn) {
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  blob.lastModifiedDate = new Date();
  blob.name = fileName;
  var name = `${prefix}/${fileName}`;
  return firebaseUpload(blob, name, onProgressFn);
}

export async function firebaseUpload(file, name, onProgressFn) {
  var path = `public/${name}`;
  var uploadTask = storageRef.child(path).put(file);
  return new Promise((resolve, reject) => {
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      // on uploadString progress,
      function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgressFn) {
          onProgressFn(progress);
        }
      },
      function (error) {
        return reject(error);
      },
      function () {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          return resolve(downloadURL);
        });
      }
    );
  });
}

export async function firebaseUploadBase64(base64Str, name, onProgressFn) {
  var path = `public/${name}`;
  var uploadTask = storageRef.child(path).putString(base64Str, "data_url");
  return new Promise((resolve, reject) => {
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      // on upload progress,
      function (snapshot) {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (onProgressFn) {
          onProgressFn(progress);
        }
      },
      function (error) {
        return reject(error);
      },
      function () {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          return resolve(downloadURL);
        });
      }
    );
  });
}

// firebase messaging
var fcmWebPushToken =
  "BMbUR2ihGL3CwH_Q2y3XFGzaihaE-cxu-rGjJQgsTUcm-UvIzAuyCpr-nnxaUx8RhjOf6NJ8QusOxgl5dqAg6nc";

function getFcmInstance() {
  if (firebase.messaging.isSupported()) {
    return firebase.messaging();
  } else {
    return {
      onMessage: async () => {
        return true;
      },
    };
  }
}

export const FirebaseMessaging = getFcmInstance();

export async function getDeviceFcmToken() {
  return new Promise((resolve, reject) => {
    // Check browser support first hand
    if (firebase.messaging.isSupported()) {
      console.log("This browser có hỗ trợ Notification. Hooray!");
      FirebaseMessaging.getToken({ vapidKey: fcmWebPushToken })
        .then((currentToken) => {
          if (currentToken) {
            return resolve(currentToken);
          } else {
            console.error(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          console.error("An error occurred while retrieving token. ", err);
          return reject(err);
        });
    } else {
      return resolve(null);
    }
  });
}
